import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';

export type SupplyListMoneyVariant = 'expenses' | 'items' | 'grand' | 'usd';

const NUM_BASE = 'text-sm tabular-nums tracking-tight leading-snug';

/** Typography tier only (no layout). Use inside flex wrappers e.g. quotation evaluation cells with ★ + amount. */
export function supplyListMoneyTypographyClass(
  variant: SupplyListMoneyVariant,
  colors: { text: string; textSecondary: string },
  /** For `usd` only: false when showing em dash */
  usdHasValue?: boolean,
): string {
  if (variant === 'expenses' || variant === 'items') {
    return cn(NUM_BASE, colors.textSecondary);
  }
  if (variant === 'grand') {
    return cn(NUM_BASE, 'font-semibold', colors.text);
  }
  return cn(
    NUM_BASE,
    'font-semibold',
    usdHasValue ? 'text-indigo-950 dark:text-indigo-200' : colors.textSecondary,
  );
}

/**
 * Shared list styling for quotation / PO / invoice money columns:
 * full-width block so values hug the right edge, tabular nums, tiered emphasis.
 */
export function supplyListMoneySpanClass(
  variant: SupplyListMoneyVariant,
  colors: { text: string; textSecondary: string },
  /** For `usd` only: false when showing em dash */
  usdHasValue?: boolean,
): string {
  return cn(
    'block w-full min-w-[6.75rem] text-right',
    supplyListMoneyTypographyClass(variant, colors, usdHasValue),
  );
}

/** Right-aligned tabular count for line-item columns on the same lists. */
export const SupplyListLineItemCountCell: React.FC<{ count: number }> = ({ count }) => {
  const { colors } = useTheme();
  return (
    <span className={cn('block w-full min-w-[2.5rem] text-right text-sm tabular-nums', colors.text)}>{count}</span>
  );
};
